import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import {
  changeParamsSettingDisableApi,
  selectParamsSetting,
} from '../../../../common/filterCompany/store/slice'
import useDidUpdateEffect from '../../../../common/hooks/useDidUpdateEffect'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import EventEmitter, {
  CHANGE_COMPANY_HEADER,
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { debounce } from '../../../../helpers/common'
import { selectUserType } from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { USER_TYPE } from '../../../../utils/authorization'
import { Input } from '../../../common/html/input'
import classes from '../index.module.scss'
import {
  changeFilter,
  selectFilterTableFilterCompany,
  selectIds,
  selectLoading,
} from '../store/slice'
import { downloadFilteredCompanies } from '../store/thunk'

export const GroupAction = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const text = useSelector(selectFilterTableFilterCompany('term'))
  const ids = useSelector(selectIds)
  const params = useSelector(selectParamsSetting)
  const loadingDownload = useSelector(selectLoading('download'))
  const userType = useSelector(selectUserType)

  const isDisable = ![USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(
    userType.userTypeId,
  )
    ? true
    : [USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId) &&
      !ids.length
    ? true
    : false

  const [inputValue, setInputValue] = useState(text)

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        changeFilter({
          term: value,
          page: 1,
        }),
      )
    }, 700),
    [],
  )

  const handelExport = () => {
    dispatch(
      downloadFilteredCompanies({
        ...params,
        term: inputValue ? inputValue.trim() : '',
      }),
    )
  }
  const handelViewPort = () => {
    if ([USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId)) {
      if (!ids.length) return
      dispatch(changeParamsSettingDisableApi(params))
      navigate(
        `${COMPONENTS.portfolioInsights.components.summary.route}?library=true`,
      )
    } else {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  //UseEffect
  useDidUpdateEffect(() => {
    handleChangeText(inputValue)
  }, [inputValue])

  useEffect(() => {
    EventEmitter.subscribe(CHANGE_COMPANY_HEADER, setInputValue)

    return () => {
      EventEmitter.unsubscribe(CHANGE_COMPANY_HEADER, setInputValue)
    }
  }, [])

  return (
    <Element
      className={classes.search}
      style={{ borderTop: '3px solid #E5E5E8' }}
    >
      <div>
        <Input
          containerStyle={{
            flex: 1,
            minWidth: 500,
            height: '28px',
          }}
          placeHolder="library.savePortfolio.SEARCH_COMPANIES"
          type="text"
          isSearch
          onChange={setInputValue}
          id="inputSearchCompanyLibrary"
          value={inputValue}
        />
      </div>

      <Element className={classes.btnAction}>
        <Button
          className={`${classes.view} cursorPointer`}
          style={{
            color: !isDisable ? '#2c73e8' : '#9C9C9C',
            backgroundColor: '#ffffff',
            border: '1px solid #6d9dcf',
            borderColor: !isDisable ? '#6d9dcf' : '#9C9C9C',
          }}
          label={
            <Element className="dFlex gap1 justifyContentCenter alignItemsCenter ">
              <Icon
                className="icon-view-insight"
                style={{
                  color: !isDisable ? '#0553A5' : '#9C9C9C',
                  fontSize: 13,
                }}
              />
              <Translate
                value="library.detailsPortfolios.VIEW_PORTFOLIO_INSIGHT"
                style={{ textTransform: 'capitalize' }}
              />
            </Element>
          }
          action={handelViewPort}
        />
        <Button
          className={`${classes.export} cursorPointer`}
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #6d9dcf',
            borderColor: ids.length ? '#6d9dcf' : '#9C9C9C',
            pointerEvents: !ids.length || loadingDownload ? 'none' : '',
            color: ids.length ? '#2c73e8' : '#9C9C9C',
          }}
          label="library.savePortfolio.EXPORT"
          action={handelExport}
          isI18n
        />
      </Element>
    </Element>
  )
}
